import axios from 'axios';
import { CookieService } from '../../services/cookie-service';
import * as Cookies from '../../constants/cookies';
import { LocalStorageService } from '../../services/local-storage-service';
import { LogService } from '../../services/log-service';

// Getter function to avoid accessing window.SS_GLOBALS at module load time (Vite timing issue)
const getCookieOptions = () => ({
  secure: window.SS_GLOBALS.frontEndConfig.forceSSL,
  sameSite: window.SS_GLOBALS.frontEndConfig.forceSSL ? 'None' : 'Lax',
});

class LoginService {
  getAuthToken({ username, password, rememberMe, recaptchaToken }) {
    return axios.post('/auth/login', {
      username,
      password,
      rememberme: rememberMe,
      recaptchatoken: recaptchaToken,
      workstationAuthorizationToken: CookieService.getCookieValue(`WS_${username.toLowerCase()}`),
    });
  }

  removeCookies(clearAllV3 = false) {
    if (clearAllV3) {
      CookieService.removeV3Config();
    }
    CookieService.removeAuthentication();
  }

  setCurrentUserInfo(userInfo) {
    LocalStorageService.setItem('v3UserInfoCache', userInfo);
  }

  getCurrentUserInfo() {
    return LocalStorageService.getItem('v3UserInfoCache');
  }

  setAuthToken(token, ttl) {
    this.removeCookies();
    const authCookieOptions = {
      domain: CookieService.getCookieDomain(),
      path: '/',
      expires: parseFloat(ttl) / 60 / 24 || undefined,
      ...getCookieOptions(),
    };

    CookieService.setCookieValue(Cookies.LegacyAuth, token, authCookieOptions);
  }

  login(authData) {
    if (!authData) {
      return;
    }
    LocalStorageService.clear();
    CookieService.setCookieValue(Cookies.InitialLogin, true, {
      domain: CookieService.getCookieDomain(),
      ...getCookieOptions(),
    });
    CookieService.removeCookie(Cookies.OnboardReturn);
    LocalStorageService.setItem('ss_sessionHandle', authData.sessionHandle);

    if (authData.redirectHost && window.location.hostname !== authData.redirectHost) {
      // oxlint-disable-next-line no-console
      console.log(`setting SSHome to ${authData.redirectHost} per server redirect`);
      CookieService.setCookieValueWithExpiration(Cookies.SSHome, authData.redirectHost, 365 * 2);

      this.setAuthToken(`CrossDomain:${authData.token}`, authData.tokenTtl);
      window.location.href = window.location.href.replace(window.location.hostname, authData.redirectHost).replace('?redirect=', '');

      return true;
    }

    this.setAuthToken(authData.token, authData.tokenTtl);
  }

  redirect(redirect = undefined) {
    window.location.href = redirect || '/';
  }

  async getLoginBehaviorRedirect() {
    try {
      const response = await axios.get('/user/loginBehavior');
      return response?.data?.redirectUri ?? null;
    } catch (error) {
      LogService.logWarning('Failed to fetch login behavior redirect', { error });
      return null;
    }
  }
}

export default new LoginService();
